export { default } from './Configurator'
